import { createSlice } from "@reduxjs/toolkit";

const selectedClient = {
  "clientId": "00:11:22:33:44:55",
  "status": "online",
  "clientName": "John's iPhone",
  "ipAddress": "192.168.1.111",
  "manufacturer": "Apple",
  "authenticationType": "WPA2-PSK",
  "connectedToDeviceName": "AP-Office-01",
  "connectedToDeviceId": "00:1A:2B:3C:4D:5E",
  "connectedToDeviceType": "ap",
  "connectType": null,
  "wirelessNetworkId": null,
  "interface": "test01",
  "vlan": 10,
  "ssid": "dlink",
  "port": null,
  "channel": 10,
  "lastSeen": 1735584000000,
  "snr": 35.5,
  "rssi": -65,
  "band": "5GHz",
  "signal": "111",
  "download": "18902384",
  "upload": "123879123",
  "traffic": "228390128390",
  "description": "",
  "isBlocked": true,
};

export const selectedClientSlice = createSlice({
  name: "selectedClient",
  initialState: {
    data: selectedClient,
  },
  reducers: {},
});

export default selectedClientSlice.reducer;
